import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {
  ProcurementCommitteeDTO,
  TenderEvaluationCommitteeDTO,
  TenderingPhaseDTO,
  ProcurementCommitteeState,
  IObjectDTO
} from '../../api/plyca-dtos';
import { EnvelopeDTO, cleanReferencedDto } from '../../api/plyca-dtos-v2';
import { TenderingBaseComponent } from './tenderingBase.component';
import { Configuration } from '../../conf/app.constants';
import { SelectItem } from 'primeng-lts/api';
import { HelpType } from '../../components/common/help/help.service';

@Component({
  selector: 'tenderingPhaseEvent',
  templateUrl: 'tenderingPhaseEvent.template.html'
})
export class TenderingPhaseEventComponent extends TenderingBaseComponent<ProcurementCommitteeDTO> implements OnInit {
  @Input()
  phase: TenderingPhaseDTO;
  @Input()
  openingCommittee: ProcurementCommitteeDTO;
  @Input()
  avaliableEvaluationCommittees: Array<TenderEvaluationCommitteeDTO>;
  @Output()
  deletedCommitee = new EventEmitter<string>();

  public eventCollapsed: boolean;

  constructor(private configuration: Configuration) {
    super();
  }
  ngOnInit(): void {
    this.eventCollapsed = this.openingCommittee && this.openingCommittee.state === ProcurementCommitteeState.CLOSED;
  }

  getTagsIdentifier(): string[] {
    return [HelpType.EDIT_FASE_LIC];
  }

  getServiceURL(): string {
    return this.configuration.PROCUREMENTCOMMITTEES_SERVICE_URL;
  }
  getFormSettingURL(): string {
    return 'procurementCommiteeISettings.json';
  }
  getDialogTitle(): string {
    return 'ProcurementCommitteeDTO.edit.title';
  }
  dtoToBean(dto: ProcurementCommitteeDTO) {
    let bean: any;
    bean = dto || {};
    if (!bean.phase) {
      bean.phase = this.phase;
    }
    let avaliableEnvelopes = this.getAvaliableEnvelopes(dto);
    if (!bean.project) {
      bean.project = this.project;
    }
    if (this.avaliableEvaluationCommittees) {
      bean.evaluationCommitteeItems = this.avaliableEvaluationCommittees.map(
        (evalCommittee: TenderEvaluationCommitteeDTO) => {
          return {
            label: evalCommittee.description,
            value: evalCommittee
          } as SelectItem;
        }
      );
    } else {
      bean.evaluationCommitteeItems = {};
    }
    if (avaliableEnvelopes) {
      bean.envelopeItems = avaliableEnvelopes
        .sort((a: EnvelopeDTO, b: EnvelopeDTO) => a.order - b.order)
        .map((envelope: EnvelopeDTO) => {
          return {
            label: envelope.description,
            value: envelope
          } as SelectItem;
        });
    } else {
      bean.envelopeItems = {};
    }
    return bean;
  }

  beanToDTO(bean: any): ProcurementCommitteeDTO {
    let dto = bean;
    // limpar propiedades auxiliares bean
    delete dto.envelopeItems;
    delete dto.evaluationCommitteeItems;
    cleanReferencedDto(dto, 'envelopes');
    cleanReferencedDto(dto, 'evaluationCommittee');
    cleanReferencedDto(dto, 'phase');
    cleanReferencedDto(dto, 'project');
    return dto as ProcurementCommitteeDTO;
  }

  protected objectDeleted(identifier: any): void {
    super.objectDeleted(identifier);
    this.deletedCommitee.next(identifier);
  }

  public getEnvelopes(): string {
    let envelopes: string;
    if (this.openingCommittee.envelopes) {
      envelopes = this.openingCommittee.envelopes
        .sort((env1: EnvelopeDTO, env2: EnvelopeDTO) => env1.order - env2.order)
        .map((envelope: EnvelopeDTO) => envelope.description)
        .join(', ');
    }
    return envelopes;
  }

  public getStateDescription(committee: ProcurementCommitteeDTO) {
    let state = committee.state;
    let desc: string;
    if (state === ProcurementCommitteeState.CLOSED) {
      desc = 'TenderingPhase.procurementCommitteeState.closed';
    } else if (state === ProcurementCommitteeState.INITIAL) {
      if (
        committee.date &&
        committee.envelopes &&
        committee.envelopes.length > 0
      ) {
        desc = 'TenderingPhase.procurementCommitteeState.scheduled';
      } else {
        desc = 'TenderingPhase.procurementCommitteeState.editing';
      }
    } else {
      desc = 'TenderingPhase.procurementCommitteeState.opened';
    }
    return this.translationService.instant(desc);
  }

  public getAvaliableEnvelopes(
    openingCommittee?: ProcurementCommitteeDTO
  ): Array<EnvelopeDTO> {
    let avaliableEnvelopes = new Array<EnvelopeDTO>();
    if (this.phase.envelopes) {
      this.phase.envelopes
        .filter(
          (phaseEnvelope: EnvelopeDTO) =>
            // si la fase no tiene eventos anyadir todos los sobres
            !this.phase.openingCommittees ||
            // si se esta creando un nuevo evento anyadir todos los sobres no asociados a otro
            (!openingCommittee &&
              this.phase.openingCommittees
                .find((phaseOpeningCommittee: ProcurementCommitteeDTO) => {
                  let notExists =
                    phaseOpeningCommittee.envelopes &&
                    phaseOpeningCommittee.envelopes.find(
                      (committeeEnvelope: EnvelopeDTO) =>
                        phaseEnvelope.identifier ===
                        committeeEnvelope.identifier
                    ) !== undefined;
                  return notExists;
                }) === undefined) ||
            // se esta editando un evento anyadir si pertenece al mismo evento o el
            // sobre no esta en otro evento
            (openingCommittee &&
              (this.phase.openingCommittees
                .filter(
                  (phaseOpeningCommittee: ProcurementCommitteeDTO) =>
                    openingCommittee.identifier ===
                    phaseOpeningCommittee.identifier
                )
                .find((phaseOpeningCommittee: ProcurementCommitteeDTO) => {
                  let exists =
                    phaseOpeningCommittee.envelopes &&
                    phaseOpeningCommittee.envelopes.find(
                      (committeeEnvelope: EnvelopeDTO) =>
                        phaseEnvelope.identifier ===
                        committeeEnvelope.identifier
                    ) !== undefined;
                  return exists;
                }) !== undefined ||
                this.phase.openingCommittees
                  .filter(
                    (phaseOpeningCommittee: ProcurementCommitteeDTO) =>
                      openingCommittee.identifier !==
                      phaseOpeningCommittee.identifier
                  )
                  .find((phaseOpeningCommittee: ProcurementCommitteeDTO) => {
                    let exists =
                      phaseOpeningCommittee.envelopes &&
                      phaseOpeningCommittee.envelopes.find(
                        (committeeEnvelope: EnvelopeDTO) =>
                          phaseEnvelope.identifier ===
                          committeeEnvelope.identifier
                      ) !== undefined;
                    return exists;
                  }) === undefined))
        )
        .forEach((envelope: EnvelopeDTO) => avaliableEnvelopes.push(envelope));
    }
    return avaliableEnvelopes;
  }

  public isStarted(openingCommittee: ProcurementCommitteeDTO): boolean {
    return openingCommittee.division && openingCommittee.division.identifier !== undefined;
  }

  public getEventClass(): string {
    let clazz: string;
    if (this.openingCommittee) {
      switch (this.openingCommittee.state) {
        case ProcurementCommitteeState.INITIAL: {
          clazz = 'phase-initial';
          break;
        }
        case ProcurementCommitteeState.CLOSED: {
          clazz = 'phase-closed';
          break;
        }
        default: {
          clazz = 'phase-others';
        }
      }
    }
    return clazz;
  }

}
